<template>
  <div class="mx-auto container">
    <div class="section-title flex flex-row">
      <span class="flex-grow"> <span>{{ session.title }}</span><span
        class="text-xs ml-2"
      >{{ session.date |displayDate }}</span></span> <span class="text-xs">{{ session.viewers.length }} Viewer</span>
    </div>

    <div class="mt-4 group">
      <h2 class="heading-m">
        Anmerkungen
      </h2>
      <div
        class="text"
        v-html="session.description"
      />
    </div>

    <div class="flex flex-col mt-4">
      <h2 class="heading-m">
        Erwärmung / Ballgewöhnung
      </h2>
      <div class="flex flex-wrap pl-4">
        <ul>
          <div
            v-for="item in session.warmups"
            :key="item.name"
          >
            <li>{{ item.name }}</li>
          </div>
        </ul>
      </div>

      <div class="flex mt-4 flex-col">
        <h2 class="heading-m">
          Ballmasteries
        </h2>

        <div class="flex  flex-col">
          <div class="flex flex-wrap pl-4">
            <ul>
              <div
                v-for="item in session.masteries"
                :key="item.name"
              >
                <li>{{ item.name }}</li>
              </div>
            </ul>
          </div>
        </div>

        <div class="flex mt-4 flex-col">
          <h2 class="heading-m">
            Hauptteil
          </h2>
          <div class="flex flex-wrap pl-4">
            <ul>
              <div
                v-for="item in session.exercises"
                :key="item.name"
              >
                <li>{{ item.name }}</li>
              </div>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiService from '.././api/apiService'

export default {
    name: 'TrainingSummary',
    data () {
        return {
            id: null,
            session: null
        }
    },
    async mounted () {
        this.id = this.$route.params.id

        if (this.id) {
            await this.load()
        }
        await apiService.setViewed(this.id)
    },
    methods: {
        async load () {
            const response = await apiService.getSsession(this.id)
            this.session = response.data
        }

    }
}
</script>

<style scoped>
  .group {
    padding: 10px;
  }

  li {
    line-height: normal;
  }
</style>